import Vue from 'vue'
import VueI18n from 'vue-i18n'
// eslint-disable-next-line camelcase
import { defaultLanguage } from '@/config'
import ba from '@/plugins/i18n/locales/ba'
import de from '@/plugins/i18n/locales/de'
import en from '@/plugins/i18n/locales/en'
import sr_latin from '@/plugins/i18n/locales/sr_latin'
import store from '@/store'

Vue.use(VueI18n)

export const loadedLanguages = ['sr_latin', 'en', 'ru', 'de', 'de-AT'] // our default language that is preloaded

let computedDefaultLang = defaultLanguage
if (window.location.hostname === 'valuator.at') {
  computedDefaultLang = 'de'
}

const currenLang = localStorage.getItem('lang')

export const i18n = new VueI18n({
  locale: !currenLang || !loadedLanguages.includes(currenLang) ? defaultLanguage : currenLang, // set locale
  fallbackLocale: defaultLanguage,
  messages: {
    sr_latin,
    en,
    ba,
    de,
    'de-AT': de, // Austrian German uses standard German translations
  }, // set locale messages
})

function setI18nLanguage(lang) {
  i18n.locale = lang
  store.commit('ui/setLang', lang)

  return lang
}

export function loadLanguageAsync(lang) {
  // If already active or loaded, just switch
  if (i18n.locale === lang || loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the base isn’t loaded, you could dynamically import it here.
  // Since you already ship packs statically above, just switch:
  return Promise.resolve(setI18nLanguage(lang))
}
